import { CommonModule }         from '@angular/common';
import { FormsModule }          from '@angular/forms';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { TranslateModule }      from '@ngx-translate/core';

import { DirectivesModule }      from '../directives/directives.module';
import { FileUploadComponent }  from '../../core/directives/file-upload/file-upload.component';
import { FlipperComponent }     from './flipper/flipper.component';
import { IconComponent }       from './icon/icon.component';
import { ImageViewModule }     from './image-viewer/image-viewer.module';
import { ListBoxComponent }    from './list-box/list-box.component';
import { WizardComponent }     from './wizard/wizard.component';
import { WizardStepComponent } from './wizard/wizard.step.component';

@NgModule({
  declarations: [
    FileUploadComponent,
    FlipperComponent,
    IconComponent,
    ListBoxComponent,
    WizardComponent,
    WizardStepComponent
  ],
  entryComponents: [
    FileUploadComponent,
    FlipperComponent,
    IconComponent,
    ListBoxComponent,
    WizardComponent,
    WizardStepComponent
  ],
  exports: [
    CommonModule,
    FormsModule,

    FileUploadComponent,
    FlipperComponent,
    IconComponent,
    ImageViewModule,
    ListBoxComponent,
    WizardComponent,
    WizardStepComponent
  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,

    //Third Party
    NgbProgressbarModule,
    TranslateModule,

    //Custom
    DirectivesModule,
    ImageViewModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ComponentsModule {}
